import { ApiContentLibrary, ApiContentLibraryResponseData } from './types';

export class ContentLibrary {
  readonly content: (Content | null)[];
  readonly totalCount: number;
  constructor(private readonly raw: ApiContentLibraryResponseData) {
    this.totalCount = raw.totalCount;
    this.content = this.toTaskContentData();
  }

  private toTaskContentData(): (Content | null)[] {
    const content = this.raw.rows;
    if (!content) {
      return [];
    }
    return content.map(c => (c ? new Content(c) : null));
  }
}

export class Content {
  public readonly id: number;
  public readonly question: string | null;
  public readonly answer: string | null;

  constructor(apiBidTaskContent: ApiContentLibrary) {
    this.id = apiBidTaskContent.id;
    this.answer = apiBidTaskContent.answer;
    this.question = apiBidTaskContent.question;
  }
}
